module.exports = __webpack_public_path__ + "static/media/wp-header.90248474.png";